import * as S from "./single.styles";
import { useEffect, useRef, useState } from "react";
import Layout from "../../component/Layout";
import ReactLoading from "react-loading";
import GaugeComponent from "react-gauge-component";
import { e2p } from "../../common/price";
import ShareIcon from "@mui/icons-material/Share";
import { toast } from "react-toastify";
import axios from "axios";
import { useParams } from "react-router-dom";
import { exportAsImage, shareImage, shareText } from "../../common/export";
import urls from "../../utils";
const SingleResult = () => {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(true);
  const exportRef = useRef();
  let { id } = useParams();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    await axios
      .get(urls.singleResult(id))
      .then((res) => {
        setResults(res.data);
      })
      .finally(() => setLoading(false))
      .catch((err) => {
        console.log(err);
      });
  };
  const reminderHandler = () => {
    axios
      .post(urls.remind, {
        id: results.request.id,
      })
      .then((res) => {
        toast.success(res.data.message);
      })
      .catch((err) => toast.error(err?.response?.data?.message));
  };

  const changeResult = (result) => {
    if (result < 5) return 10;
    if (result < 10 && result >= 5) return 30;
    if (result < 20 && result >= 10) return 50;
    if (result <= 30 && result >= 20) return 70;
    if (result > 30) return 90;
  };
  const LoacationHandler = () => {
    window.open(
      "https://pwap.tebinja.com/categories",
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  const LoacationcolsHandler = () => {
    window.open(
      "https://pwap.tebinja.com/categories/9/doctors",
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  const LoacationdiabetHandler = () => {
    window.open(
      "https://pwap.tebinja.com/categories/31/doctors",
      "_blank" // <- This is what makes it open in a new window.
    );
  };
  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ReactLoading
            type={"spokes"}
            color={"#5ed2d2"}
            height={100}
            width={100}
          />
        </div>
      ) : (
        <>
          {results.request.age >= 40 ? (
            <div ref={exportRef}>
              <header>
                <S.nav
                  color={changeResult(results.request.result)}
                  className="navbar"
                ></S.nav>
                <S.BgHeader color={changeResult(results.request.result)}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "start",
                      justifyContent: "center",
                      height: "105px",
                    }}
                  >
                    <S.GaugeComponent
                      className="gaugeComponent"
                      as={GaugeComponent}
                      type="semicircle"
                      style={{ width: 250 }}
                      arc={{
                        cornerRadius: 7,
                        width: 0.219,
                        subArcs: [
                          {
                            limit: 0,
                            color: "#40C955",
                          },
                          {
                            limit: 20,
                            color: "#40C955",
                          },
                          {
                            limit: 40,
                            color: "#A4D634",
                          },
                          {
                            limit: 60,
                            color: "#FEE114",
                          },
                          {
                            limit: 80,
                            color: "#F5A120",
                          },
                          {
                            color: "#E63832",
                          },
                        ],
                      }}
                      pointer={{
                        color: "#345243",
                        width: 13,
                      }}
                      labels={{}}
                      value={changeResult(results.request.result)}
                      minValue={0}
                      maxValue={100}
                    />
                  </div>
                </S.BgHeader>
              </header>
              <Layout>
                <S.Container>
                  <S.ResultHealth color={changeResult(results.request.result)}>
                    <S.ResultHealthTitle>
                      ریسک ابتلا به سکته قلبی و مغزی شما
                    </S.ResultHealthTitle>
                    <S.ResultHealthRenge
                      color={changeResult(results.request.result)}
                    >
                      %{e2p(results.request.result)}
                    </S.ResultHealthRenge>
                  </S.ResultHealth>
                  <S.ResultSummary>
                    <S.ResultSummaryText>
                      نتیجه پایش سلامت به منظور راهنمایی و اطلاع‌رسانی عمومی
                      طراحی شده است و نباید جایگزین مشاوره، تشخیص و یا تجویز
                      پزشکی شود. در صورت وجود هرگونه نگرانی یا سوال پزشکی، توصیه
                      می‌شود با یک پزشک متخصص مشورت کنید.
                      <S.BtnWrapper>
                        <S.BtnCounseling onClick={LoacationHandler}>
                          مشاوره و دریافت نسخه
                        </S.BtnCounseling>
                      </S.BtnWrapper>
                    </S.ResultSummaryText>
                  </S.ResultSummary>

                  <S.Actions>
                    <S.BtnWrapperHead
                      color={changeResult(results.request.result)}
                    >
                      <S.BtnAdd
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderRadius: "4px",
                          width: "120px",
                          boxShadow: "0px 4px 10px 0px rgba(0,0,0, 0.3)",
                        }}
                        onClick={() =>
                          shareImage(exportRef.current, "premature-result.png")
                        }
                      >
                        اشتراک گذاری
                        <ShareIcon style={{ fontSize: "1rem" }} />
                      </S.BtnAdd>
                      <S.BtnCounseling
                        style={{ borderRadius: "4px", width: "120px" }}
                        onClick={() => {
                          exportAsImage(exportRef.current, "result");
                        }}
                      >
                        {" "}
                        دانلود pdf
                      </S.BtnCounseling>
                    </S.BtnWrapperHead>
                    <S.ActionsTitle>اقدامات توصیه شده</S.ActionsTitle>
                    <S.ResultCardAction
                      color={changeResult(results.request.result)}
                    >
                      {results.request.result > 8 ? (
                        <S.CardTitle>
                          ریسک ابتلا به سکته قلبی و مغزی و در نتیجه آن مرگ
                          زودرس، برای شما در حد بالا است. برای پیشگیری از ابتلا
                          به سکته زودرس اقدامات زیر را انجام دهید. به شما
                          اطمینان می‌دهیم که این ریسک بالا کاملا قابل کنترل و
                          پیشگیری است.
                        </S.CardTitle>
                      ) : (
                        <S.CardTitle>
                          خوشبختانه شما جزو گروه کم خطر محسوب مي شويد و لازم است
                          اقدامات زير را براي حفظ سلامتي و پيشگيري از مرگ زودرس
                          انجام دهيد.
                        </S.CardTitle>
                      )}
                    </S.ResultCardAction>
                    {results.actions.followup ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          {e2p(results.actions.followup)} ماه دیگر برای تست مجدد
                          مراجعه کنید
                        </S.CardTitle>
                        <S.BtnWrapper>
                          <S.BtnAdd
                            onClick={reminderHandler}
                            style={{
                              borderRadius: "4px",
                              boxShadow: "0px 4px 10px 0px rgba(0,5,20, 0.3)",
                            }}
                          >
                            افزودن به لیست پیگیری
                          </S.BtnAdd>
                        </S.BtnWrapper>
                      </S.ActionsCard>
                    ) : (
                      ""
                    )}
                    {results.actions.bmi >= 25 ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          {" "}
                          با توجه به نسبت قد و وزنتان، شما دارای اضافه وزن
                          هستید. همین مورد ممکن است سلامتی شما را با مخاطراتی
                          روبرو کند. بنابراین با داشتن یک رژیم غذایی مناسب،
                          افزایش فعالیت منظم ورزشی روزانه برای رسیدن به وزن
                          مطلوب تلاش کنید.
                        </S.CardTitle>
                      </S.ActionsCard>
                    ) : (
                      <S.ActionsCard>
                        <S.CardTitle>
                          خوشبختانه وزن شما در محدوده وزن نرمال قرار دارد. برای
                          حفظ این وضعیت لازم است که رژیم غذایی سالم، پرهیز از
                          پرخوری و فعالیت منظم ورزشی داشته باشید.
                        </S.CardTitle>
                      </S.ActionsCard>
                    )}
                    {results.actions.alcohol ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          {" "}
                          در صورت مصرف الکل ، آن را ترک کنید{" "}
                        </S.CardTitle>
                      </S.ActionsCard>
                    ) : (
                      ""
                    )}
                    {results.request.smoker ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          سیگار کشیدن می‌تواند تا ۱۰% احتمال ابتلا به بیماری‌های
                          قلب و عروق را افزایش دهد و همچنین ریسک ابتلا به
                          سرطان‌ها، بیماری‌های تنفسی را افزایش دهد. بنابراین هر
                          چه سریع‌تر برای ترک سیگار اقدام کنید.
                        </S.CardTitle>
                      </S.ActionsCard>
                    ) : (
                      <S.ActionsCard>
                        <S.CardTitle>
                          با دوری از سیگار، ریسک بسیاری از بیماری‌ها را کاهش
                          می‌دهید و به خود و اطرافیان‌تان فرصت زندگی سالم‌تری
                          می‌دهید. به این تصمیم ارزشمند خود افتخار کنید و به حفظ
                          سلامت خود ادامه دهید.
                        </S.CardTitle>
                      </S.ActionsCard>
                    )}
                    {results.actions.activity ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          {results.actions.activity &&
                            `۳۰ دقیقه در روز و یا ۵ روز در هفته، ورزش کنید، طوری که ورزش موجب عرق کردن شما شود. همچنین به طور روزمره تحرک داشته باشید مثلا به جای استفاده از آسانسور از پله استفاده کنید.`}
                        </S.CardTitle>{" "}
                      </S.ActionsCard>
                    ) : (
                      ""
                    )}

                    {results.request.bps === 159 ||
                    results.request.bps === 179 ||
                    results.request.bps === 180 ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          فشار خون شما در محدوده نگران کننده‌ای قرار دارد و باید
                          در اسرع وقت زیر نظر پزشک متخصص برای کنترل آن اقدام
                          کنید.
                          <br /> از مصرف نمک به طور جدی خودداری کنید. میزان نمک
                          مورد نیاز بدن ۵ گرم در روز است که در نان و غذاهای
                          آماده وجود دارد. از اضافه کردن نمک اضافی به غذا پرهیز
                          کنید.
                          <br /> فشار خون بالای کنترل نشده از عوامل اصلی افزایش
                          خطر ابتلا به بیماری‌های جدی مانند انواع بیماری‌ قلبی،
                          کلیوی و سکته قلبی و مغزی است. فشار خون خود را هر ماه
                          یک بار اندازه گيری كنيد و به ياد داشته باشيد ميزان
                          طبيعی آن زير عدد ۱۲ برای فشار ماکزیموم و زير عدد ۸
                          برای فشار مينيمم است.
                        </S.CardTitle>
                        {results.actions.bpsDrug ? (
                          <>
                            <S.CardTitle>
                              احتمالا برای کنترل فشارخون ، تحت نظر پزشک نیاز به
                              مصرف دارو دارید.
                            </S.CardTitle>
                            <S.BtnWrapper>
                              <S.BtnAdd onClick={LoacationcolsHandler}>
                                مشاوره و دریافت نسخه
                              </S.BtnAdd>
                            </S.BtnWrapper>
                          </>
                        ) : (
                          ""
                        )}
                      </S.ActionsCard>
                    ) : results.request.bps === 139 ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          فشار خون شما در محدوده‌ مرزی قرار دارد و در صورت عدم
                          توجه به این شرایط، ممکن است در آینده به فشار خون بالا
                          منجر شود. بنابراین برای کنترل این وضعیت حتما با یک
                          پزشک متخصص مشورت کنید و به صورت دوره‌ای چکاپ انجام
                          دهید. از مصرف نمک به طور جدی خودداری کنید. میزان نمک
                          مورد نیاز بدن 5 گرم در روز است که در نان و غذاهای
                          آماده وجود دارد. از اضافه کردن نمک اضافی به غذا پرهیز
                          کنید. فشار خون بالای کنترل نشده از عوامل اصلی افزایش
                          خطر ابتلا به بیماری‌های جدی مانند انواع بیماری‌ قلبی،
                          کلیوی و سکته قلبی و مغزی است. فشار خون خود را هر ماه
                          یک بار اندازه گيری كنيد و به ياد داشته باشيد ميزان
                          طبيعی آن زير عدد ۱۲ برای فشار ماکزیموم و زير عدد ۸
                          برای فشار مينيمم است.
                        </S.CardTitle>
                        {results.actions.bpsDrug ? (
                          <>
                            <S.CardTitle>
                              احتمالا برای کنترل فشارخون ، تحت نظر پزشک نیاز به
                              مصرف دارو دارید.
                            </S.CardTitle>
                            <S.BtnWrapper>
                              <S.BtnAdd onClick={LoacationcolsHandler}>
                                مشاوره و دریافت نسخه
                              </S.BtnAdd>
                            </S.BtnWrapper>
                          </>
                        ) : (
                          ""
                        )}
                      </S.ActionsCard>
                    ) : results.request.bps === 119 ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          خوشبختانه فشار خون شما در محدوده نرمال است. با ادامه
                          رژیم غذایی مناسب و کم نمک و فعالیت ورزشی روزانه در حفظ
                          این حالت تلاش کنید.
                          <br />
                          همچنین خوب است این نکته را بدانید که یکی از جنبه‌های
                          خطرناک فشار خون بالا، عدم آگاهی فرد از این بیماری است.
                          تنها راه آگاهی از ابتلا به فشار خون بالا انجام معاینات
                          و چکاپ منظم به خصوص در سنین بالای ۴۰ سال است. فشار خون
                          بالای کنترل نشده از عوامل اصلی افزایش خطر ابتلا به
                          بیماری‌های جدی مانند انواع بیماری‌ قلبی، کلیوی و سکته
                          قلبی و مغزی است.
                          <br />
                          فشار خون خود را هر ماه یک بار اندازه گيری كنيد و به
                          ياد داشته باشيد ميزان طبيعی آن زير عدد ۱۲ برای فشار
                          ماکزیموم و زير عدد ۸ برای فشار مينيمم است.
                          <br />
                          از مصرف نمک به طور جدی خودداری کنید. میزان نمک مورد
                          نیاز بدن ۵ گرم در روز است که در نان و غذاهای آماده
                          وجود دارد. از اضافه کردن نمک اضافی به غذا پرهیز کنید.
                        </S.CardTitle>
                        {results.actions.bpsDrug ? (
                          <>
                            <S.CardTitle>
                              احتمالا برای کنترل فشارخون ، تحت نظر پزشک نیاز به
                              مصرف دارو دارید.
                            </S.CardTitle>
                            <S.BtnWrapper>
                              <S.BtnAdd onClick={LoacationcolsHandler}>
                                مشاوره و دریافت نسخه
                              </S.BtnAdd>
                            </S.BtnWrapper>
                          </>
                        ) : (
                          ""
                        )}
                      </S.ActionsCard>
                    ) : (
                      ""
                    )}
                    {results.request.cholesterol === 7 ||
                    results.request.cholesterol === 6 ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          میزان کلسترول شما در محدوده خطرناک است که یکی از عوامل
                          مهم ابتلا به بیماری‌های قلبی-عروقی است و باید در اسرع
                          وقت به پزشک مراجعه کنید. علاوه بر اصلاح سبک زندگی و
                          عادات تغذیه‌ای، لازم است تحت نظر پزشک داروهای کاهنده
                          کلسترول خون دریافت کنید.
                        </S.CardTitle>
                        {results.actions.statinDrug ? (
                          <S.BtnWrapper>
                            <S.BtnAdd onClick={LoacationcolsHandler}>
                              مشاوره و دریافت نسخه
                            </S.BtnAdd>
                          </S.BtnWrapper>
                        ) : (
                          ""
                        )}
                      </S.ActionsCard>
                    ) : results.request.cholesterol === 5 ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          میزان کلسترول خون شما در محدوده‌ی مرزی قرار دارد و
                          باید در اسرع وقت با یک پزشک مشورت کنید تا رژیم غذایی و
                          سبک زندگی شما اصلاح شود و در صورت نیاز دارو دریافت
                          کنید.
                        </S.CardTitle>
                        {results.actions.statinDrug ? (
                          <S.BtnWrapper>
                            <S.BtnAdd onClick={LoacationcolsHandler}>
                              مشاوره و دریافت نسخه
                            </S.BtnAdd>
                          </S.BtnWrapper>
                        ) : (
                          ""
                        )}
                      </S.ActionsCard>
                    ) : results.request.cholesterol === 4 ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          میزان کلسترول شما هنوز در محدوده‌ی نرمال قرار دارد،
                          اما بهتر است با پزشک خود مشورت کنید تا از وضعیت
                          دقیق‌تری مطلع شوید. توجه به رعایت رژیم غذایی و فعالیت
                          روزانه و دوری از عوامل ریسک زا مثل سیگار کشیدن که منجر
                          به افزایش کلسترول می‌شود بسیار مهم است.
                        </S.CardTitle>
                        {results.actions.statinDrug ? (
                          <S.BtnWrapper>
                            <S.BtnAdd onClick={LoacationcolsHandler}>
                              مشاوره و دریافت نسخه
                            </S.BtnAdd>
                          </S.BtnWrapper>
                        ) : (
                          ""
                        )}
                      </S.ActionsCard>
                    ) : results.request.cholesterol === 3.9 ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          خوشبختانه میزان کلسترول شما در محدوده نرمال قرار دارد.
                          داشتن کلسترول در این محدوده به کاهش خطر ابتلا به
                          بیماری‌های قلبی و عروقی کمک می‌کند. همچنین توصیه
                          می‌شود برای پایداری این شرایط، سبک زندگی و تغذیه سالم
                          خود را ادامه دهید و زیر نظر پزشک چکاپ دوره‌ای انجام
                          دهید.
                        </S.CardTitle>
                        {results.actions.statinDrug ? (
                          <S.BtnWrapper>
                            <S.BtnAdd onClick={LoacationcolsHandler}>
                              مشاوره و دریافت نسخه
                            </S.BtnAdd>
                          </S.BtnWrapper>
                        ) : (
                          ""
                        )}
                      </S.ActionsCard>
                    ) : (
                      ""
                    )}
                    {results.request.hasDiabetes ? (
                      <S.ActionsCard>
                        <S.CardTitle>
                          قند خون بالا یک بیماری متابولیک مزمن است که می‌تواند
                          منجر به آسیب به اعصاب و عروق بدن شود. برای کنترل قند
                          خون، حتما باید به صورت منظم تحت نظر پزشک باشید.
                          <br />
                          بهتر است آزمايش قند و چربی خون و تست‌های زير را سالی
                          يک بار انجام دهيد.
                          <br />
                          FBS, HBA1c, TG, cholesterol, LDL, HDL, AST, ALT, Alk
                          Plos. ‌
                        </S.CardTitle>
                        <S.BtnWrapper>
                          <S.BtnAdd onClick={LoacationdiabetHandler}>
                            مشاوره و دریافت نسخه
                          </S.BtnAdd>
                        </S.BtnWrapper>
                      </S.ActionsCard>
                    ) : (
                      <S.ActionsCard>
                        <S.CardTitle>
                          قند خون شما در محدوده نرمال قرار دارد. برای حفظ این
                          وضعیت، ادامه دادن به رژیم غذایی مناسب، فعالیت بدنی
                          منظم و کنترل وزن و چکاپ دوره‌ای بسیار اهمیت دارد.
                          <br />
                          بهتر است آزمايش قند و چربی خون و تست‌های زير را سالی
                          يک بار انجام دهيد.
                          <br />
                          FBS, HBA1c, TG, cholesterol, LDL, HDL, AST, ALT, Alk
                          Plos.
                        </S.CardTitle>
                      </S.ActionsCard>
                    )}
                    {!results.actions.statinDrug && !results.actions.bpsDrug ? (
                      <S.ActionsCard>
                        <S.CardTitle> مشاوره با پزشک متخصص</S.CardTitle>
                        <S.BtnWrapper>
                          <S.BtnCounseling onClick={LoacationHandler}>
                            شروع مشاوره
                          </S.BtnCounseling>
                        </S.BtnWrapper>
                      </S.ActionsCard>
                    ) : (
                      ""
                    )}
                  </S.Actions>
                  <S.Actions>
                    <S.ActionsTitle> جدول میزان مصرف کالری</S.ActionsTitle>
                    <S.CalorieCard bg={true}>
                      <S.TextTable>تغییرات وزن</S.TextTable>

                      <S.TextTable>میزان درصد مصرف کالری</S.TextTable>
                      <S.TextTable>میزان کالری مصرفی در روز</S.TextTable>
                    </S.CalorieCard>
                    {results.actions.calorie.map((item) => {
                      return (
                        <S.CalorieCard>
                          <S.TextTable dir="ltr">
                            {" "}
                            {e2p(item.change)}
                          </S.TextTable>
                          <S.TextTable> {e2p(item.percent)} </S.TextTable>
                          <S.TextTable dir="ltr">
                            {" "}
                            {e2p(item.value)}{" "}
                          </S.TextTable>
                        </S.CalorieCard>
                      );
                    })}
                  </S.Actions>
                </S.Container>
              </Layout>
            </div>
          ) : (
            <div ref={exportRef}>
              <header>
                <S.nav className="navbar"></S.nav>
                <S.BgHeader></S.BgHeader>
              </header>
              <Layout>
                <S.Container>
                  <S.ResultSummary>
                    <S.ResultSummaryText>
                      از اینکه برای سلامتی خود ارزش قائل هستید و در این تست شرکت
                      کردید از شما سپاسگزاریم؛ خوشبختانه شما در این سن جزو گروه
                      کم خطر محسوب می‌شوید و با رعایت مواردی برای داشتن زندگی
                      سالم‌تر، می‌توانید ریسک ابتلا به سکته قلبی و مغزی، به خصوص
                      در سنین بالای ۴۰ سال را کاهش دهید. انجام این تست برای
                      افراد بالای ۴۰ سال به دلیل احتمال بیشتر ابتلای آنان به
                      بیماری‌های قلب و عروق الزامی است. بنابراین این تست را برای
                      افراد بالای ۴۰ سال که می‌شناسید ارسال کنید و از آن‌ها
                      بخواهید بیشتر مراقب سلامتی خود باشند.
                    </S.ResultSummaryText>
                  </S.ResultSummary>

                  <S.Actions>
                    <S.BtnWrapperHead
                      color={changeResult(results.request.result)}
                    >
                      <S.BtnCounseling
                        style={{ borderRadius: "4px", width: "120px" }}
                        onClick={LoacationHandler}
                      >
                        مشاوره با پزشک
                      </S.BtnCounseling>
                      <S.BtnAdd
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderRadius: "4px",
                          width: "120px",
                          boxShadow: "0px 4px 10px 0px rgba(0,0,0, 0.3)",
                        }}
                        onClick={() =>
                          shareText(
                            window.location.protocol +
                              "//" +
                              window.location.hostname,
                            "پایش سلامت طبینجا",
                            "لطفا برای افراد بالای ۴۰ ارسال کنید "
                          )
                        }
                      >
                        دعوت از دوستان
                        <ShareIcon style={{ fontSize: "1rem" }} />
                      </S.BtnAdd>
                    </S.BtnWrapperHead>
                    <S.ActionsTitle>
                      {" "}
                      توصیه‌هایی برای زندگی سالم‌تر
                    </S.ActionsTitle>
                    <S.ActionsCard>
                      <S.CardTitle>
                        به صورت روزمره تحرک بدنی داشته باشید، مثلا به جای
                        استفاده از آسانسور از پله استفاده کنید.
                      </S.CardTitle>
                    </S.ActionsCard>

                    <S.ActionsCard>
                      <S.CardTitle>
                        از مصرف نمک به طور جدی خودداری کنید. میزان نمک مورد نیاز
                        بدن ۵ گرم در روز است که در نان و غذاهای آماده وجود دارد.
                        از اضافه کردن نمک اضافی به غذا پرهیز کنید.
                      </S.CardTitle>
                    </S.ActionsCard>
                    <S.ActionsCard>
                      <S.CardTitle>
                        از پرخوری پرهیز کنید و وزن خود را کنترل کنید.
                      </S.CardTitle>
                    </S.ActionsCard>

                    <S.ActionsCard>
                      <S.CardTitle>{` حداقل ۳۰ دقیقه ورزش کنید، طوری که ورزش موجب عرق کردن شود. `}</S.CardTitle>
                    </S.ActionsCard>
                    <S.ActionsCard>
                      <S.CardTitle>
                        فشار خون خود را هر ماه يك بار اندازه گيری كنيد و به ياد
                        داشته باشيد ميزان طبيعی آن زير عدد ۱۲ برای فشار ماکزیموم
                        و زير عدد ۸ برای فشار مينيمم است.
                      </S.CardTitle>
                    </S.ActionsCard>
                    <S.ActionsCard>
                      <S.CardTitle>
                        بهتر است آزمايش قند و چربی خون و تست‌های زير را سالی
                        يكبار انجام دهيد. FBS, HBA1c, TG, cholesterol, LDL, HDL,
                        AST, ALT, Alk Plos.
                      </S.CardTitle>
                    </S.ActionsCard>
                    <S.ActionsCard>
                      <S.CardTitle> مشاوره با پزشک متخصص</S.CardTitle>
                      <S.BtnWrapper>
                        <S.BtnCounseling onClick={LoacationHandler}>
                          مشاوره با پزشک
                        </S.BtnCounseling>
                      </S.BtnWrapper>
                    </S.ActionsCard>
                  </S.Actions>
                  <S.Actions>
                    <S.ActionsTitle> جدول میزان مصرف کالری</S.ActionsTitle>
                    <S.CalorieCard bg={true}>
                      <S.TextTable>تغییرات وزن</S.TextTable>

                      <S.TextTable>میزان درصد مصرف کالری</S.TextTable>
                      <S.TextTable>میزان کالری مصرفی در روز</S.TextTable>
                    </S.CalorieCard>
                    {results.actions.calorie.map((item) => {
                      return (
                        <S.CalorieCard>
                          <S.TextTable dir="ltr">
                            {" "}
                            {e2p(item.change)}
                          </S.TextTable>
                          <S.TextTable> {e2p(item.percent)} </S.TextTable>
                          <S.TextTable dir="ltr">
                            {" "}
                            {e2p(item.value)}{" "}
                          </S.TextTable>
                        </S.CalorieCard>
                      );
                    })}
                  </S.Actions>
                </S.Container>
              </Layout>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default SingleResult;
